// `maxGuestsPerEvent` caps the guest list of every event in the workspace.
// `null` means the tier carries no cap of its own and the global
// HARD_LIMIT_FOR_GUESTS_PER_EVENT applies. A workspace can override its tier's
// value through `plan.maxGuestsPerEvent`, and a single event through
// `plan.maxGuests` (see _get-max-guests-per-event.js).
const subscriptionConfigs = {
  distributor_sandbox: {
    aiCredits: 15,
    mailingCredits: 25,
    maxGuestsPerEvent: 100,
  },

  distributor_sandbox_extended: {
    aiCredits: 50,
    mailingCredits: 200,
    maxGuestsPerEvent: 100,
  },

  distributor: {
    aiCredits: 150,
    mailingCredits: 1000,
    maxGuestsPerEvent: 100,
  },

  free_monthly: {
    aiCredits: 10,
    mailingCredits: 50,
    maxGuestsPerEvent: null,
  },

  pro_monthly: {
    aiCredits: 50,
    mailingCredits: 500,
    maxGuestsPerEvent: null,
  },

  teams_monthly: {
    aiCredits: 150,
    mailingCredits: 1000,
    maxGuestsPerEvent: null,
  },
};

// All known plan tiers, derived from the configs above so the schema enums and
// the configs never diverge.
export const PLAN_TIERS = Object.keys(subscriptionConfigs);

// Distributor-family tiers. Only these carry a self-managed `plan.endsAt`; the
// monthly tiers are owned by Stripe and must never be expired by us.
export const DISTRIBUTOR_TIERS = PLAN_TIERS.filter((tier) => tier.startsWith('distributor'));

export default subscriptionConfigs;
